import { AnyAction, Reducer } from 'redux';
import { DashboardState } from '../models/dashboardModel';
import actionTypes from '../types/dashboardTypes';

const initialState: DashboardState = {
  pbiData: null,
  metricsBoardFilter: {},
  isFilterApplied: false,
  dashboardType: '',
  isMetricsBoardPDFDownload: false,
  hospitalWisePayer: [],
};

const dashboardReducer: Reducer = (
  state: DashboardState = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.DASHBOARD_FILTER_REQUESTED: {
      return {
        ...state,
        pbiData: null,
      };
    }

    case actionTypes.DASHBOARD_FILTER_SUCCESS: {
      return {
        ...state,
        pbiData: action.payload,
      };
    }

    case actionTypes.SET_METRICS_BOARD_FILTER: {
      const { metricsBoardFilter } = action?.payload;
      const isFilterApplied =
        metricsBoardFilter?.searchCenter?.length > 0 ||
        metricsBoardFilter?.searchPayer?.length > 0 ||
        metricsBoardFilter?.fromMonth ||
        metricsBoardFilter?.toMonth;

      return {
        ...state,
        metricsBoardFilter: action?.payload?.metricsBoardFilter,
        dashboardType: action?.payload?.dashboardType,
        isFilterApplied,
      };
    }

    case actionTypes.DOWNLOAD_METRICS_BOARD_PDF_REQUESTED: {
      return {
        ...state,
        isMetricsBoardPDFDownload: true,
      };
    }
    case actionTypes.SET_IS_DOWNLOAD_METRICS_BOARD_PDF: {
      return {
        ...state,
        isMetricsBoardPDFDownload: action.payload,
      };
    }
    case actionTypes.SET_METRICS_BOARD_PAYER: {
      return {
        ...state,
        hospitalWisePayer: action.payload,
      };
    }

    default: return state;
  }
};

export default dashboardReducer;
